import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useAuth } from "~/state/auth";
import { formatDistanceStrict } from "date-fns";

export default function InactivityTimeout() {
  const auth = useAuth();
  const inactivity = auth.inactivity;

  const remainingDistanceLabel = formatDistanceStrict(
    inactivity.remainingSeconds,
    0
  );

  return (
    <Dialog open={inactivity.promptOpen || inactivity.timeExpired} fullWidth>
      <DialogTitle>Your session is about to expire.</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You will be signed out in {remainingDistanceLabel}. Do you want to
          stay signed in?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => inactivity.onInactive()}
          disabled={inactivity.timeExpired}
        >
          Sign out
        </Button>
        <Button
          onClick={inactivity.promptConfirm}
          disabled={inactivity.timeExpired}
        >
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
}
